module.exports = __webpack_public_path__ + "f72b8a6a3440e90fd2d6015526473bbd.svg";